import { Translations } from './index';

export const ptBR: Translations = {
  app: {
    name: 'Buscador de Eventos',
    tagline: 'Descubra Eventos no Mundo Todo',
    description: 'Descubra eventos de organizações, universidades e cidades com busca alimentada por IA',
  },

  header: {
    searchPlaceholder: 'Buscar eventos, tópicos ou locais...',
    searchingEvents: 'Buscando eventos...',
    noSuggestionsFound: 'Nenhuma sugestão encontrada',
    searchButton: 'Buscar',
    categoriesView: 'Categorias',
    mapView: 'Eventos perto de mim',
    calendarView: 'Vista do Calendário',
    feedback: 'Feedback',
    createGroup: 'Criar grupos de eventos',
    myEvents: 'Meus eventos',
    menu: 'Menu',
    howItWorks: 'Como funciona',
    latestUpdates: 'Últimas atualizações',
    upcomingShort: 'próximos',
  },

  suggestions: {
    locations: 'Locais',
    entities: 'Empresas de tecnologia, corporações, universidades e organizações',
    events: 'Eventos',
    location: 'Local',
    relevance: 'Relevância',
  },

  homepage: {
    heroTitle: 'Descubra Eventos Incríveis',
    heroSubtitle: 'Encontre e explore eventos que combinam com seus interesses com nossa busca alimentada por IA',
    popularEvents: 'Eventos Populares',
    topCities: 'Principais Cidades',
    viewAllEvents: 'Ver Todos os Eventos',
    exploreEvents: 'Explorar Eventos',
    discoverEvents: 'Descobrir Eventos',
    findEventsNearby: 'Encontrar Eventos Próximos',
    liveStats: {
      ariaLabel: 'Atividade atual do Event Finder',
      upcoming: 'Próximos',
      inPerson: 'Presenciais',
      virtual: 'Virtuais',
      hybrid: 'Híbridos',
      organizations: 'Organizações',
      partners: 'empresas de tecnologia',
      companies: 'corporações',
      webSources: 'Fontes web',
      cities: 'cidades',
      countries: 'países',
      continents: 'continentes',
      addedPastWeek: 'adicionados em 7 dias',
      updated: 'Atualizado',
      fresh: 'Dados recentes',
      loading: 'Carregando atividade atual',
    },
  },

  events: {
    upcoming: 'Próximos',
    past: 'Passados',
    virtual: 'Virtual',
    inPerson: 'Presencial',
    free: 'Grátis',
    paid: 'Pago',
    eventDetails: 'Detalhes do evento',
    venue: 'Local',
    date: 'Data',
    time: 'Horário',
    location: 'Localização',
    organizer: 'Organizador',
    category: 'Categoria',
    register: 'Registrar',
    moreInfo: 'Mais informações',
    noEventsFound: 'Nenhum evento encontrado',
    loadingEvents: 'Carregando eventos...',
    relatedTo: 'Relacionado a',
    duration: 'Duração',
    eventSource: 'Fonte do evento',
    universityHosted: 'Organizado por uma universidade',
    universityFallbackName: 'uma universidade',
    universityAttendanceNotice: 'Este evento é organizado por {university}. Eventos universitários podem ter restrições de participação ou elegibilidade. Consulte a página do evento ou os detalhes da inscrição antes de participar.',
    universityCampusPrecision: 'nível do campus (universidade anfitriã)',
  },

  browse: {
    title: 'Explorar Eventos',
    searchResultsTitle: 'Resultados da pesquisa para "{query}"',
    searchResultsDescription: 'Descubra eventos relacionados a "{query}" usando pesquisa alimentada por IA',
    noResultsTitle: 'Nenhum evento encontrado',
    noResultsDescription: 'Tente ajustar seus critérios de pesquisa ou filtros',
    showingResults: 'Mostrando {count} de {total} eventos',
    filtersApplied: 'Filtros aplicados',
  },

  map: {
    title: 'Eventos perto de mim',
    subtitle: 'Explore eventos ao redor do mundo',
    eventsNearby: 'Eventos Próximos',
    showingEvents: 'Mostrando eventos',
    zoomToArea: 'Ampliar para a área',
    currentLocation: 'Localização Atual',
    enableLocation: 'Ativar Localização',
    failedToLoadEvents: 'Falha ao carregar eventos. Tente novamente mais tarde.',
    failedToGetLocation: 'Falha ao obter sua localização. Ative os serviços de localização.',
  },

  calendar: {
    title: 'Calendário de Eventos',
    subtitle: 'Visualizar eventos por data',
    monthView: 'Visualização Mensal',
    weekView: 'Visualização Semanal',
    dayView: 'Visualização Diária',
    today: 'Hoje',
    nextMonth: 'Próximo Mês',
    previousMonth: 'Mês Anterior',
    eventsToday: 'Eventos de Hoje',
    noEventsThisDay: 'Nenhum evento agendado para este dia',
  },

  filters: {
    filterBy: 'Filtrar Por',
    dateRange: 'Intervalo de Datas',
    location: 'Local',
    category: 'Categoria',
    price: 'Preço',
    eventType: 'Tipo de Evento',
    clearFilters: 'Limpar Filtros',
    applyFilters: 'Aplicar Filtros',
    startDate: 'Data de Início',
    endDate: 'Data de Fim',
    anyPrice: 'Qualquer Preço',
    freeOnly: 'Apenas Gratuito',
    paidOnly: 'Apenas Pago',
    anyType: 'Qualquer Tipo',
    virtualOnly: 'Apenas Virtual',
    inPersonOnly: 'Apenas Presencial',
  },

  actions: {
    search: 'Buscar',
    clear: 'Limpar',
    cancel: 'Cancelar',
    save: 'Salvar',
    edit: 'Editar',
    delete: 'Excluir',
    share: 'Compartilhar',
    export: 'Exportar',
    print: 'Imprimir',
    refresh: 'Atualizar',
    back: 'Voltar',
    next: 'Próximo',
    previous: 'Anterior',
    close: 'Fechar',
    submit: 'Enviar',
  },

  time: {
    today: 'Hoje',
    tomorrow: 'Amanhã',
    yesterday: 'Ontem',
    thisWeek: 'Esta Semana',
    nextWeek: 'Próxima Semana',
    thisMonth: 'Este Mês',
    nextMonth: 'Próximo Mês',
    morning: 'Manhã',
    afternoon: 'Tarde',
    evening: 'Noite',
    night: 'Madrugada',
    days: {
      monday: 'Segunda-feira',
      tuesday: 'Terça-feira',
      wednesday: 'Quarta-feira',
      thursday: 'Quinta-feira',
      friday: 'Sexta-feira',
      saturday: 'Sábado',
      sunday: 'Domingo',
    },
    months: {
      january: 'Janeiro',
      february: 'Fevereiro',
      march: 'Março',
      april: 'Abril',
      may: 'Maio',
      june: 'Junho',
      july: 'Julho',
      august: 'Agosto',
      september: 'Setembro',
      october: 'Outubro',
      november: 'Novembro',
      december: 'Dezembro',
    },
  },

  errors: {
    general: 'Ocorreu um erro. Tente novamente.',
    networkError: 'Erro de rede. Verifique sua conexão.',
    notFound: 'O item solicitado não foi encontrado.',
    unauthorized: 'Você não está autorizado a acessar este recurso.',
    serverError: 'Erro do servidor. Tente novamente mais tarde.',
    invalidInput: 'Entrada inválida. Verifique seus dados.',
    tryAgainLater: 'Tente novamente mais tarde.',
    pageNotFound: 'Página não encontrada.',
    locationError: 'Não foi possível acessar sua localização.',
  },

  success: {
    eventSaved: 'Evento salvo com sucesso!',
    filtersSaved: 'Filtros salvos com sucesso!',
    settingsUpdated: 'Configurações atualizadas com sucesso!',
    feedbackSubmitted: 'Feedback enviado com sucesso!',
  },

  loading: {
    general: 'Carregando...',
    events: 'Carregando eventos...',
    suggestions: 'Carregando sugestões...',
    map: 'Carregando mapa...',
    calendar: 'Carregando calendário...',
    searching: 'Buscando...',
  },

  categories: {
    technology: 'Tecnologia',
    business: 'Negócios',
    education: 'Educação',
    healthcare: 'Saúde',
    entertainment: 'Entretenimento',
    sports: 'Esportes',
    arts: 'Artes',
    science: 'Ciência',
    community: 'Comunidade',
    networking: 'Networking',
    conference: 'Conferência',
    workshop: 'Workshop',
    seminar: 'Seminário',
    meetup: 'Encontro',
    webinar: 'Webinar',
  },

  footer: {
    companyName: 'Event Finder',
    companyDescription: 'Descubra e conecte-se com eventos incríveis ao redor do mundo. De encontros locais a conferências internacionais, ajudamos você a encontrar experiências que importam para você.',
    contactEmail: 'ola@eventfinder.site',
    contactPhone: '+55 (11) 1234-EVENT',
    contactAddress: 'São Paulo, SP',
    
    // CTA Section
    ctaTitle: 'Pronto para Descobrir Eventos Incríveis?',
    ctaDescription: 'Use o botão de feedback no cabeçalho para compartilhar seus pensamentos e nos ajudar a melhorar sua experiência de descoberta de eventos.',
    ctaButton: 'Dar Feedback',
    
    // Quick Links Section
    quickLinksTitle: 'Links Rápidos',
    aboutUs: 'Sobre Nós',
    ourServices: 'Nossos Serviços',
    blogResources: 'Blog e Recursos',
    latestUpdates: 'Últimas atualizações',
    careers: 'Carreiras',
    helpCenter: 'Central de Ajuda',
    contact: 'Contato',
    
    // Platform Section
    platformTitle: 'Plataforma',
    browseEvents: 'Explorar Eventos',
    eventCalendar: 'Calendário de Eventos',
    advancedSearch: 'Busca Avançada',
    apiDocumentation: 'Documentação da API',
    mobileApp: 'Aplicativo Móvel',
    siteMap: 'Mapa do Site',
    siteStatistics: 'Estatísticas do Site',
    
    // Trust & Safety Section
    trustSafetyTitle: 'Confiança e Segurança',
    securityCenter: 'Centro de Segurança',
    accessibility: 'Acessibilidade',
    communityGuidelines: 'Diretrizes da Comunidade',
    trustSafety: 'Confiança e Segurança',
    reportIssue: 'Reportar Problema',
    
    // Trust Badges
    sslSecured: 'SSL Seguro',
    iso27001: 'ISO 27001',
    gdprCompliant: 'Compatível com LGPD',
    
    // Legal Links
    privacyPolicy: 'Política de Privacidade',
    termsOfService: 'Termos de Serviço',
    cookiePolicy: 'Política de Cookies',
    disclaimer: 'Isenção de Responsabilidade',
    
    // Copyright
    copyright: '©',
    allRightsReserved: 'Todos os direitos reservados',
  },

  howItWorks: {
    title: 'Como funciona o Event Finder',
    subtitle: 'Descoberta de eventos alimentada por IA em escala',
    heroTitle: 'Event Finder: Descoberta de eventos alimentada por IA em escala',
    heroSubtitle: 'Descubra como usamos tecnologia IA de ponta para encontrar eventos em milhares de sites em todo o mundo',
    
    challengeTitle: 'O desafio: Encontrar agulhas no palheiro digital',
    challengeDescription: 'Imagine tentar monitorar manualmente milhares de sites de eventos ao redor do mundo para descobrir próximos eventos, conferências, workshops e sessões de treinamento. Cada site tem layouts diferentes, cronogramas de atualização e formatos. Alguns anunciam eventos com meses de antecedência, outros apenas semanas. Perder um único evento importante poderia significar perder valiosas oportunidades de negócio.',
    
    solutionTitle: 'A solução alimentada por IA: Descoberta web inteligente',
    solutionDescription: 'O Event Finder transforma essa tarefa manual impossível em um sistema de descoberta automatizado e inteligente que funciona 24/7.',
    
    aiVisionTitle: '🧠 Sistema de visão IA duplo',
    aiVisionDescription: 'O sistema emprega duas abordagens de IA complementares para garantir que nenhum evento passe despercebido:',
    
    primaryMethodTitle: '1. Inteligência Markdown',
    primaryMethodSubtitle: 'Método principal',
    primaryMethodDescription: 'Nossa abordagem principal converte sites complexos em dados estruturados e limpos para análise de IA.',
    primaryMethodFeatures: {
      webScraping: 'Web Scraping avançado: Converte sites HTML complexos em texto markdown estruturado e limpo',
      gptProcessing: 'Processamento GPT-4o-mini: Usa LLMs recentes da OpenAI para entender e extrair informações de eventos do texto',
      contextUnderstanding: 'Compreensão de contexto: A IA não apenas procura palavras-chave—ela entende contexto, datas, localizações e tipos de eventos'
    },
    
    fallbackMethodTitle: '2. Análise IA visual',
    fallbackMethodSubtitle: 'Método de backup',
    fallbackMethodDescription: 'Quando a análise de texto não é suficiente, nossa IA visual intervém para interpretar conteúdo web como um humano faria.',
    fallbackMethodFeatures: {
      screenshotTechnology: 'Tecnologia de captura de tela: Captura instantâneos visuais de sites usando automação Chrome',
      computerVision: 'Visão computacional: Usa GPT-4o com capacidades de visão para "ver" e interpretar conteúdo web como um humano faria',
      layoutIntelligence: 'Inteligência de layout: Reconhece listas de eventos, calendários e anúncios independentemente do design do site'
    },
    
    smartMatchingTitle: '🎯 Correspondência inteligente de eventos e deduplicação',
    smartMatchingDescription: 'O verdadeiro poder vem de prevenir sobrecarga de informações:',
    
    vectorSimilarityTitle: 'Correspondência de similaridade vetorial',
    vectorSimilarityFeatures: {
      semanticUnderstanding: 'Compreensão semântica: Usa embeddings avançados para entender que "Workshop Azure" e "Treinamento Microsoft Cloud" podem ser o mesmo evento',
      intelligentDeduplication: 'Deduplicação inteligente: Previne que o mesmo evento seja registrado múltiplas vezes em diferentes sites de eventos',
      confidenceScoring: 'Pontuação de confiança: Cada correspondência recebe uma pontuação de confiança, garantindo precisão'
    },
    
    fuzzyLogicTitle: 'Processamento de lógica fuzzy',
    fuzzyLogicFeatures: {
      dateIntelligence: 'Inteligência de data: Entende que "Próxima terça-feira" e "15 de março" podem se referir à mesma data',
      locationMatching: 'Correspondência de localização: Reconhece que "Seattle, WA" e "Seattle, Washington" são o mesmo lugar',
      titleVariations: 'Variações de título: Captura eventos mesmo quando empresas usam nomes ligeiramente diferentes'
    },
    
    processingPipelineTitle: '🔄 Pipeline de processamento inteligente',
    processingPipelineDescription: 'O sistema opera através de uma arquitetura sofisticada baseada em filas que processa milhares de sites eficientemente:',
    processingPipelineFeatures: {
      qualityControl: 'Controle de qualidade automatizado',
      freshnessFiltering: 'Filtragem de frescor: Remove automaticamente eventos com mais de 2 semanas para manter dados atuais',
      dataValidation: 'Validação de dados: Garante que informações de eventos estejam completas e adequadamente formatadas',
      errorRecovery: 'Recuperação de erro: Se um método falha, o sistema automaticamente tenta abordagens alternativas'
    },
    
    cloudArchitectureTitle: '🚀 Arquitetura em nuvem escalável',
    cloudArchitectureDescription: 'Construído na infraestrutura de nível empresarial do Azure:',
    cloudArchitectureFeatures: {
      parallelProcessing: 'Processamento paralelo: Pode analisar centenas de sites simultaneamente',
      autoScaling: 'Auto-escalabilidade: Ajusta automaticamente recursos baseado na carga de trabalho',
      faultTolerance: 'Tolerância a falhas: Continua processando mesmo se sites individuais estiverem fora do ar',
      globalReach: 'Alcance global: Processa sites de todo o mundo em múltiplos fusos horários'
    },
    
    resultsTitle: 'Os resultados incríveis',
    resultsDescription: 'Nosso sistema alimentado por IA entrega performance excepcional e valor de negócio.',
    
    businessValueTitle: '💡 Valor de negócio',
    businessValueForBD: 'Para desenvolvimento de negócios: Nunca perca oportunidades de parceria, descubra eventos conjuntos e possibilidades de colaboração, obtenha inteligência competitiva e veja tendências da indústria meses antes.',
    businessValueForMarketing: 'Para equipes de marketing: Encontre oportunidades de conteúdo, patrocínios de eventos, oportunidades de fala, insights de audiência e eventos de alto valor para participação.',
    businessValueForSales: 'Para equipes de vendas: Gere leads de participantes de eventos, construa relacionamentos em encontros da indústria e obtenha inteligência de mercado sobre necessidades dos clientes.',
    
    technologyStackTitle: 'O stack tecnológico: IA de primeira classe',
    azureOpenAITitle: '🤖 Integração Azure OpenAI: GPT-4o e GPT-4o-mini para compreensão de conteúdo, modelos de embeddings de texto para similaridade semântica e capacidades de visão para processamento de conteúdo visual.',
    azureSearchTitle: '🔍 Azure AI Search: Busca vetorial para encontrar eventos similares, busca semântica para compreensão de intenção e indexação em tempo real de novos eventos.',
    analyticsTitle: '📊 Analytics abrangentes: Application Insights para monitoramento, dashboards customizados para rastreamento de tendências e métricas de qualidade para medir precisão.',
    
    realWorldImpactTitle: 'Impacto no mundo real',
    realWorldImpactDescription: 'Imagine descobrir que três dos seus principais parceiros estão organizando conferências de IA no mesmo mês, dando oportunidades para coordenar marketing, planejar eventos complementares, evitar conflitos e criar parcerias. Ou encontrar tendências tecnológicas emergentes semanas antes delas se tornarem mainstream.',
    
    ctaTitle: 'Pronto para desbloquear a inteligência oculta em milhares de sites?',
    ctaDescription: 'Os eventos de amanhã estão sendo planejados hoje—certifique-se de ser o primeiro a saber sobre eles.',
    ctaButton: 'Explorar eventos agora'
  },

  regional: {
    currency: 'BRL',
    dateFormat: 'DD/MM/YYYY',
    timeFormat: '24-hour',
    numberFormat: '1.234,56',
    phoneFormat: '+55 (11) 12345-6789',
    addressFormat: 'Rua, Cidade, Estado, CEP',
  },
};
